<template>
  <div class="overall-bg header-top">
    <ApprovalConfirmation v-if="
      ApprovalListchange.length != 0 &&
      ApprovalListchange.some((item) => item['IsApproved'] == 0) &&
      Number(QueryStringValue?.IsApproval) !== 1
    " :approvaldata="ApprovalListchange" :approvaldetails="approvaldetails" @triggerDetails="getApprovaldata()"
      @Approve="Approve" :SuccessfullPopUp="SuccessfullPopUp" />
    <ApprovalStatus v-if="
      ApprovalList.length != 0 && Number(QueryStringValue?.IsApproval) !== 1
    " :ApprovalgetList="ApprovalList" :approvaldetails="approvaldetails" />
    <b-container class="">
      <div class="form-white-bg">
        <b-container>
          <b-row>
            <b-col>
              <BacktoPage :goback="$router.back" v-if="Number(QueryStringValue?.IsApproval) !== 1"></BacktoPage>
            </b-col>
          </b-row>
          <b-row v-if="loading" class="pt-3">
            <b-col sm="6" cols="12">
              <Skeleton width="12rem" />
            </b-col>
            <b-col sm="6" cols="12">
              <Skeleton height="2rem" width="7rem" class="float-end" />
            </b-col>
          </b-row>
          <b-row v-else>
            <b-col xl="6" md="6" sm="6" cols="12" class="pt-5">
              <p class="light-txt">{{ SummaryName }} Summary</p>
            </b-col>
            <b-col xl="6" md="6" sm="6" cols="12" class="pt-5" v-if="Number(QueryStringValue?.IsApproval) !== 1">
              <div class="float-end d-flex align-items-center gap-3 flex-column">
                <RedStatus name="PO Amendment Cancelled" v-if="details.Postatus == 5 && details.IsApproved == 0" />
                <RedStatus name="PO Cancelled" v-if="details.Postatus == 4 && details.IsApproved == 1" />

                <div class="d-flex align-items-center gap-1" v-if="details.Postatus == 4 && details.IsApproved == 1">
                  <lable>Cancelled Reason:</lable>
                  <p>{{ details.CancelReason }}</p>
                </div>

                <AddButton btnname="Revert" v-if="details.Postatus == 4 && details.IsApproved == 1" @click="RevertPO" />

                <Button v-if="
                  details.Postatus != 5 &&
                  details.Postatus != 4 &&
                  details.Postatus != 1
                " class="Actionsbtn p-button-sm" label="Actions" severity="info" @click="toggle" aria-haspopup="true"
                  icon="pi pi-angle-down" aria-controls="overlay_menu" iconPos="right" size="small" />
                <Menu ref="menu" id="overlay_menu" :model="items" :popup="true" />
              </div>
            </b-col>
          </b-row>
        </b-container>

        <b-row v-if="loading" class="pt-3">
          <b-row>
            <b-col xl="4" lg="3" sm="4" md="6" cols="12">
              <MobileLoader />
            </b-col>
          </b-row>
        </b-row>

        <b-row class="px-3" v-else>
          <b-col lg="4" xl="4" xxl="4" md="8" sm="8">
            <Card class="summarycard">
              <template #title>
                <b-row>
                  <b-col cols="8">
                    <p class="card-font">{{ details.Po }}</p>
                    <p class="card-font">
                      <span><i class="pi pi-calendar"></i>{{
                        // getConvertedDate(details.Podate, "D MMM YYYY | h:mmA")
                        details.Podate
                      }}</span>
                    </p>
                  </b-col>
                  <b-col cols="4" class="d-flex flex-row-reverse card-font">
                    <p>₹ {{ details.Price }}</p>
                  </b-col>
                </b-row>
              </template>
              <template #content>
                <b-row class="mb-2 mt-3">
                  <b-col>
                    <h6>Supplier Information</h6>
                    <div class="d-flex">
                      <p class="light-txt me-3">Name:</p>
                      <p>
                        {{ details.SupplierName }}
                      </p>
                    </div>
                    <div class="d-flex my-2">
                      <p class="light-txt me-3">Address:</p>
                      <p>
                        {{ details.SupplierAddress ?? details.Address }}
                      </p>
                    </div>

                    <div class="d-flex my-2">
                      <p class="light-txt me-3">GST:</p>
                      <p>
                        {{ details.GST }}
                      </p>
                    </div>
                  </b-col>
                  <!-- <b-col>
                      <h6>DELIVERY TERMS</h6>
                      <p>{{ details.DeliveryTerms }}</p>
                    </b-col> -->
                </b-row>
                <b-row>
                  <b-col>
                    <h6 class="fn14">Payment Terms</h6>
                    <p class="termstxt">
                      {{ removeHtmlTags(details.Paymentterms) }}
                    </p>
                  </b-col>
                  <b-col>
                    <h6 class="fn14">Delivery Terms</h6>
                    <p class="termstxt">
                      {{ removeHtmlTags(details.deliveryterms) }}
                    </p>
                  </b-col>
                </b-row>
              </template>
            </Card>
          </b-col>
        </b-row>
        <div class='field' v-if="uploadedTableList.length != 0">
          <label class=" mb-0">{{ $t("PurchaseRequest.QuotationFile") }}</label>
        </div>
        <b-row>
          <b-col lg="3" md="4" sm="6" cols="12" class="d-flex mb-3" v-for="item in uploadedTableList">
            <div class="fileuploadcard my-2" :title="item.fileName">
              <div>
                <p class="filenametxt">{{ item.fileName }}</p>
                <div class="blue-txt" id="file-name" @click="fileviewer(item.fullPath)">
                  view </div>
              </div>
            </div>
          </b-col>
        </b-row>
        <!-- <b-row class="px-3 pt-5">
          <b-col>
            <p class="light-txt">{{ SummaryName }} Details</p>
          </b-col>
        </b-row> -->
      </div>
    </b-container>
    <b-container class="">
      <PODetailsItemMapping @additem="AddItems" :QueryValue="QueryStringValue" />
    </b-container>
  </div>

  <Dialog v-model:visible="ObjCancelPopUp.CancelReasonPopup" modal :header="ObjCancelPopUp.PopUpHeaderName"
    :breakpoints="{
      '1980px': '55vw',
      '1440px': '60vw',
      '960px': '70vw',
      '640px': '90vw',
    }" class="overall-bg">
    <b-container fluid>
      <b-row>
        <b-col>
          <div class="field">
            <Textarea :name="ObjCancelPopUp.TextAareaName" :label="ObjCancelPopUp.TextAareaName"
              :rules="{ required: false }" :id="ObjCancelPopUp.TextAareaName" v-model="ObjCancelPopUp.CancelReason" />
            <Footer class="p-3" @cancel="ObjCancelPopUp.CancelReasonPopup = false" @save="SaveCancelPO" />
          </div>
        </b-col>
      </b-row>
    </b-container>
  </Dialog>

  <CancelSuccessfully :content="ModelPopupDunction.CancelModelTxt" :visible="ModelPopupDunction.Cancelpop"
    @ok="cancelclose()" />
  <RevertedSuccessfully :content="ModelPopupDunction.RevertModelTxt" :visible="ModelPopupDunction.Revertpop"
    @ok="cancelclose()" />
  <CancelConfirmation :Editmodel="ModelPopupDunction.cancelmodel" @yes="Statuschange()"
    @no="ModelPopupDunction.cancelmodel = false" :header="ObjCancelPopUp.ConfirmPopupHeader"
    :content="ObjCancelPopUp.ConfirmPopupContent" />
  <!-- <UserDetails :trigger="showpopModal" @close="showpopModal = false" /> -->
  <Toast />
</template>

<script lang="ts">
import { defineComponent, ref, Ref, onMounted, watch } from "vue";
import LeftBar from "../../../../../modules/Inventory/components/MasterDetails/LeftSideBar.vue";
import Details from "../../../../../modules/Inventory/components/MasterDetails/Details.vue";
import MemberDetails from "../../../../../modules/Inventory/components/MasterDetails/MemberDetails.vue";
import StockWOFileUploadServices from "../../../../../modules/Inventory/Service/StockWOFileUploadService";

// import Rightsidebar from '../../../../modules/Inventory/components/Sidebar/RightSidebar/ItemDetailsSidebar.vue'
import UserDetails from "../../../../../modules/Inventory/components/Sidebar/RightSidebar/UserDetailsRightSidebar.vue";
import Log from "../../../../../modules/Inventory/components/Sidebar/RightSidebar/UserDetailsRightSidebar.vue";
import BacktoPage from "../../../../../components/FormComponents/BacktoMaster.vue";
import Headerlayout from "../../../../../components/Masters/HeaderLayout.vue";
import POTableview from "../../../../../modules/Inventory/pages/Transaction/PurchaseOrder/POTable.vue";
import commonService from "../../../Service/WithoutStockAffectService";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import CancelConfirmation from "../../../../../components/FormComponents/CancelConfirmation.vue";
import CancelSuccessfully from "../../../../../components/FormComponents/CancelSuccessfully.vue";
import RevertedSuccessfully from "../../../../../components/FormComponents/createdsuccessfully.vue";
import service from "../../../Service/SupplierMaster";
import PoApprovalService from "../../../Service/PoApprovalService";

import Loader from "../../../../../components/FormComponents/Loader.vue";
import PODetailsItemMapping from "../../../../../modules/Inventory/components/MasterDetails/TabsPage/PODetailsItemMapping.vue";
import MobileLoader from "../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import ApprovalConfirmation from "../../../../../components/FormComponents/ApprovalConfirmation.vue";
import ApprovalStatus from "../../../../../components/FormComponents/ApprovalStatus.vue";
import moment from "moment";
import supplierService from "../../../../../modules/Inventory/Service/SupplierMaster";
import DeliveryTermsService from "../../../../../modules/Inventory/Service/DeliveryTermsService";
import { useToast } from "primevue/usetoast";
import Textarea from "../../../../../components/FormComponents/TextArea.vue";
import Footer from "../../../../../components/FormComponents/Footer.vue";
import ConfirmPopup from "primevue/confirmpopup";
import { setupHistoryManagement } from "../../../../../modules/Inventory/Service/HistoryManage";
import { useI18n } from "vue-i18n";

export default defineComponent({
  components: {
    CancelSuccessfully,
    CancelConfirmation,
    LeftBar,
    Details,
    MemberDetails,
    UserDetails,
    Log,
    BacktoPage,
    Headerlayout,
    POTableview,
    PODetailsItemMapping,
    Loader,
    MobileLoader,
    ApprovalConfirmation,
    ApprovalStatus,
    Textarea,
    Footer,
    RevertedSuccessfully,
  },

  props: {
    Operations: {
      type: Object,
      default: () => ({}),
    },
    ApprovalObj: {
      type: Object,
      default: () => ({}),
    },
  },

  setup(props, { emit }) {
    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }
    let HospitalId = Number(usersData.OrganizationId);
    let BranchId = Number(usersData.BranchId);

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }
    //

    let DeptRoleMapId = Number(rolesData.DeptRoleMapId);

    const { t } = useI18n();
    debugger;
    let Id = ref([]);
    const router = useRouter();

    const routes = useRoute();
    const toast = useToast();
    const isActive = ref(false);
    const menu = ref();
    const buttonValue = ref(true);
    const POAmendmentshow = ref(true);

    let loading = ref(false);
    let sidebardata = ref([]);
    const showmodalref = ref(false);
    const activeIndex = ref(0);
    const currentStatus = ref("process");
    let SummaryName = ref("");
    let uploadedTableList: any = ref([])

    let ApprovalList = ref([]);
    let ApprovalListchange = ref([]);
    let itemslist: any = ref([]);

    let QueryStringValue = ref(routes.query);

    watch(
      () => [props.Operations, props.ApprovalObj],
      ([newOperations, newApprovalObj]) => {
        debugger;
        if (newOperations.Id) {
          QueryStringValue.value = newOperations;
        }

        if (newApprovalObj.Status) {
          isForm.value.IsApproved = newApprovalObj.Status;
          UpdateApprovalStatus();
        }
      },
      { immediate: true, deep: true }
    );

    const ModelPopupDunction = ref({
      cancelmodel: false,
      CancelModelTxt: "",
      Cancelpop: false,

      Revertmodel: false,
      RevertModelTxt: "",
      Revertpop: false,
    });

    let ObjCancelPopUp = ref({
      CancelReasonPopup: false,
      CancelReason: "",
      PopUpHeaderName: "",
      TextAareaName: "",
      ConfirmPopupHeader: "",
      ConfirmPopupContent: "",
    });

    const ObjCancelPO = ref({
      Id: 0,
      Status: "0",
      Amount: 0.0,
      EntityId: 0,
      EntityOperationId: 0,
      DeptRoleId: 0,
      CreatedBy: 0,
      HospitalId: 0,
      BranchId: 0,
      CancelReason: "",
      IsApproved: 0,
      Type: 0,
      StoreId: 0,
      DocNo: "",
    });

    let details: any = ref({
      SupplierId: 0,
      Price: "",
      Podate: "",
      Paymentterms: "",
      DeliveryTerms: "",
      Po: "",
      RefNo: "",
      SupplierName: "",
      Address: "",
      SupplierAddress: "",
      // suppliername: "",
      GST: "",
      DocType: "",
      StoreId: 0,
      Postatus: 0,
      CreatedAt: "",
      Email: "",
      BranchId: 0,
      HospitalId: 0,
      IsApproved: 0,
      CancelReason: "",
      StoreDeliveryAddress: "",
      EntityId: 0,
    });

    let approvaldetails: any = ref({
      HeaderName: "PO",
      ContentName: "Purchase Order",
      ApprovalCode: 0,
      ApprovalDate: "",
      ApprovalPrice: 0,
      CreatedAt: "",
    });

    let CreatePOAmendment = ref(false);
    let CancelPO = ref(false);
    let CancelPOAmendment = ref(false);
    let VSendMail = ref(false);

    onMounted(() => {
      POdetails();
      if (QueryStringValue.value.IsApproval != "1") {
        getApprovaldata();
      }
    });

    const handleClick = () => {
      showmodalref.value = true;
    };

    function cancelclose() {
      debugger;
      ModelPopupDunction.value.Cancelpop = false;
      //router.back();

      setupHistoryManagement(router, 2);
    }

    const toggle = (event: MouseEvent) => {
      debugger;

      if (details.value.Postatus == 0 && details.value.DocType == "4") {
        CreatePOAmendment.value = true;
      }

      if (
        details.value.Postatus == 0 &&
        details.value.IsApproved == 1 &&
        (details.value.DocType == "4" || details.value.DocType == "5")
      ) {
        CancelPO.value = true;
      }

      if (details.value.Postatus == 0 && details.value.DocType == "6") {
        CancelPOAmendment.value = true;
      }
      if (ApprovalListchange.value[0]?.["IsApproved"] == "1") {
        VSendMail.value = true;
      }
      menu.value.toggle(event);
    };

    const items = ref([
      {
        items: [
          {
            label: "Create an Amendment PO",
            visible: CreatePOAmendment,
            command: async () => {
              debugger;
              router.push({
                name: "POCreation",
                path: "/POCreation",
                query: {
                  formId: 1026,
                  param: "POAmendment",
                  doctype: 6,
                  Id: QueryStringValue.value.Id,
                  StoreId: details.value.StoreId,
                },
              });
            },
          },
          {
            label: "Cancel PO",
            icon: "deleteicon pi pi-ban",
            visible: CancelPO,
            command: async () => {
              CancelPOOnClick();
            },
          },
          {
            label: "Cancel PO Amendment",
            icon: "deleteicon pi pi-times",
            visible: CancelPOAmendment,
            command: async () => {
              ModelPopupDunction.value.cancelmodel = true;
            },
          },
          {
            label: "Send E-Mail",
            icon: "editicon pi pi-envelope",
            // visible: VSendMail,
            command: async () => {
              ExportSendMail();
            },
          },
        ],
      },
    ]);

    async function ExportSendMail() {
      debugger;
      try {
        debugger;
        let obj = {
          FormId: 14,
          ModuleId: 3,
          OrganizationId: HospitalId,
          BranchId: QueryStringValue.value.BranchId,
          JsonValue:
            "{ Id:" +
            QueryStringValue.value.Id +
            ",hospitalid:'" +
            HospitalId +
            "',branchid:'" +
            QueryStringValue.value.BranchId +
            "'}",
          FileName: details.value.Po,
          PathView: "PO",
          DeptRoleId: DeptRoleMapId,
          EntityTransactionId: Number(QueryStringValue.value.Id),
          EntityOperationId: 3044001,
          Email: details.value.Email,
          SupplierName: details.value.SupplierName,
          PONumber: details.value.Po,
          PODate: moment(details.value.Podate).format("dd MMM yyyy | h:mma"),
          TotalAmount: Number(details.value.Price || 0.00),
          DeliveryAddress: details.value.Address,
          ItemList: itemslist.value,
          UserId: usersData.UserId,
          UserName: usersData.UserName,
          ContactAddress: usersData.AddressVar,
          PhoneNumber: usersData.phoneNumber,
          Position: rolesData.RoleName,
          StoreDeliveryAddress: details.value.StoreDeliveryAddress,
        };

        const result = await commonService.ExportSendMail(obj);
        if (result["result"] == "Success") {
          toast.add({
            severity: "success",
            summary: "Mail Sent Successfully",
            detail: "",
            life: 3000,
          });
        }
        console.log(result);
      } catch (error) {
        console.log(error);
      }
    }

    const next = () => {
      if (activeIndex.value === 3) activeIndex.value = 0;
      else activeIndex.value++;
      isActive.value = true;
    };

    const prev = () => {
      if (activeIndex.value === 0) activeIndex.value = 3;
      else activeIndex.value--;
    };

    const item = ref([
      {
        label: "Personal",
        to: "/",
      },
      {
        label: "Seat",
        to: "/Masters",
      },
      {
        label: "Payment",
        to: "/SupplierMasterCreation",
      },
      {
        label: "Confirmation",
        to: "/GenericMasterTableview",
      },
    ]);

    const POdetails = async () => {
      debugger;
      try {
        loading.value = true;

        const response = await commonService.GetByStockWOTransId(
          QueryStringValue.value.Id
        );
        debugger;
        let data = response["result"][0];
        console.log("sdjhsdhjdsjhsdjh", response["result"][0]);
        console.log(data);
        details.value.Price = Number(data.grossamount).toFixed(2);
        details.value.SupplierId = data.SupplierId;
        details.value.Podate = data.DocDateHR;
        details.value.Po = data.DocNo;
        details.value.RefNo = data.RefNo;
        details.value.CreatedAt = data.CreatedAt;

        details.value.DocType = data.DocType;
        details.value.StoreId = data.StoreId;
        details.value.Postatus = data.Status;

        details.value.BranchId = data.BranchId;
        details.value.HospitalId = data.HospitalId;
        details.value.IsApproved = data.IsApproved;
        details.value.CancelReason = data.CancelReason;

        details.value.EntityId = data.EntityId;

        approvaldetails.value.ApprovalCode = data.DocNo;
        approvaldetails.value.ApprovalDate = data.DocDateHR;
        approvaldetails.value.CreatedAt = data.CreatedAt;
        approvaldetails.value.ApprovalPrice = data.grossamount;

        if (details.value.DocType == "4" || details.value.DocType == "5") {
          SummaryName.value = "PO";
        } else if (details.value.DocType == "6") {
          SummaryName.value = "PO Amendment";
        } else {
          console.log(details.value.DocType);
        }

        if (details.value.DocType == "6") {
          buttonValue.value = false;
          POAmendmentshow.value = true;
        }

        details.value.Paymentterms = data.PaymentTermsName;
        details.value.deliveryterms = data.DeliveryTermsName;
        details.value.StoreDeliveryAddress = data.DeliveryAddress;
        details.value.SupplierAddress = data.SupplierAddress;

        getfindonedata();
        const FileUploadresult = await StockWOFileUploadServices.getStockWOFileById(
          QueryStringValue.value.Id
        );
        if (FileUploadresult['result'].length > 0) {
          for (let i = 0; i < FileUploadresult['result'].length; i++) {
            let Fileobj = {};
            (Fileobj["url"] = FileUploadresult['result'][i].FileName.split('/FileUpload/')[1]),
              (Fileobj["fileName"] = FileUploadresult['result'][i].FileName.split('/').pop()),
              (Fileobj["fileType"] = Fileobj["url"].split('/')[0]),
              (Fileobj["fullPath"] = FileUploadresult['result'][i].FileName),
              (Fileobj["Id"] = FileUploadresult['result'][i].Id),
              uploadedTableList.value.push(Fileobj)
          }
        }
        else {
          uploadedTableList.value = [];
        }
        loading.value = false;
      } catch (error) {
        alert(error);
      }
    };

    async function getfindonedata() {
      debugger;
      try {
        let response = await service.EditData(details.value.SupplierId);
        debugger;
        const data1 = response["result"][0];
        console.log(data1);

        details.value.SupplierName = data1.Name;
        details.value.Address = data1.Address;
        details.value.GST = data1.GSTNO;
        details.value.Email = data1.Email;
      } catch (error) {
        console.log(error);
      }
    }

    function datapass() {
      debugger;

      router.push({
        name: "POCreation",
        path: "/POCreation",
      });
    }

    function CancelPOOnClick() {
      debugger;

      ObjCancelPopUp.value.PopUpHeaderName = t("confirmation.cancelpo");
      ObjCancelPopUp.value.TextAareaName = t("confirmation.cancelreason");
      ObjCancelPopUp.value.CancelReason = "";

      ObjCancelPopUp.value.CancelReasonPopup = true;

      ObjCancelPO.value.EntityId = details.value.Po;
      ObjCancelPO.value.EntityOperationId = 3044005;
      ObjCancelPO.value.Status = "4";
      ObjCancelPO.value.IsApproved = 0;
      ObjCancelPO.value.Type = 1;
      ObjCancelPO.value.DocNo = details.value.EntityId;

      ObjCancelPopUp.value.ConfirmPopupHeader = t("confirmation.confirmcancel");
      ObjCancelPopUp.value.ConfirmPopupContent = t(
        "confirmation.doyouwanttocancel"
      );
    }

    function RevertPO() {
      debugger;

      ObjCancelPopUp.value.PopUpHeaderName = t("confirmation.revertpo");
      ObjCancelPopUp.value.TextAareaName = t("confirmation.revertreason");
      ObjCancelPopUp.value.CancelReason = "";

      ObjCancelPopUp.value.CancelReasonPopup = true;

      ObjCancelPO.value.EntityId = details.value.Po;
      ObjCancelPO.value.EntityOperationId = 3044006;
      ObjCancelPO.value.Status = "0";
      ObjCancelPO.value.IsApproved = 0;
      ObjCancelPO.value.Type = 2;
      ObjCancelPO.value.DocNo = details.value.EntityId;

      ObjCancelPopUp.value.ConfirmPopupHeader = t("confirmation.conformrevert");
      ObjCancelPopUp.value.ConfirmPopupContent = t(
        "confirmation.doyouwanttorevert"
      );
    }

    function SaveCancelPO() {
      debugger;
      if (ObjCancelPopUp.value.CancelReason == "") {
        toast.add({
          severity: "info",
          summary: "Enter Reason",
          detail: "",
          life: 3000,
        });
      } else {
        ModelPopupDunction.value.cancelmodel = true;
      }
    }

    const Statuschange = async () => {
      debugger;
      try {
        ObjCancelPO.value.Id = Number(QueryStringValue.value.Id);
        ObjCancelPO.value.CancelReason = ObjCancelPopUp.value.CancelReason;
        ObjCancelPO.value.BranchId = details.value.BranchId;
        ObjCancelPO.value.HospitalId = details.value.HospitalId;
        ObjCancelPO.value.DeptRoleId = rolesData.DeptRoleMapId;
        ObjCancelPO.value.StoreId = rolesData.StoreId;

        if (details.value.DocType == "4" || details.value.DocType == "5") {
          ModelPopupDunction.value.CancelModelTxt = t(
            "confirmation.pocancelsuccess"
          );
        } else {
          ObjCancelPO.value.Status = "5";
          ModelPopupDunction.value.CancelModelTxt = t(
            "confirmation.poammendcancelsuccess"
          );
        }
        const response = await commonService.StockWOOutStatusChanged(
          ObjCancelPO.value
        );

        let message = response["ErrorInfo"].ErrorCode;

        if (message == null) {
          ModelPopupDunction.value.cancelmodel = false;
          if (ObjCancelPO.value.EntityOperationId == 3044005) {
            ModelPopupDunction.value.Cancelpop = true;
          } else if (ObjCancelPO.value.EntityOperationId == 3044006) {
            ModelPopupDunction.value.RevertModelTxt = t(
              "confirmation.porevertsuccess"
            );
            ModelPopupDunction.value.Revertpop = true;
          }
        } else {
          alert("Somthing went wrong");
        }
      } catch (error) {
        console.log(error);
      }
    };

    const convertedDate = ref("");
    const getConvertedDate = (dateString, format) => {
      convertedDate.value = moment(dateString).format(format);
      return convertedDate.value;
    };

    async function getApprovaldata() {
      debugger;
      try {
        let response = await PoApprovalService.GetPOApprovalList(
          QueryStringValue.value.Id,
          usersData.OrganizationId,
          QueryStringValue.value.BranchId,
          QueryStringValue.value.EntityId
        );

        // routes.query.Id

        ApprovalList.value = response["result"];
        ApprovalListchange.value = response["result"].filter(
          (item) => item.DepRoleID == DeptRoleMapId
        );
        console.log("approval data", ApprovalList.value);
      } catch (error) {
        console.log(error);
      }
    }

    let SuccessfullPopUp = ref({
      accept: ref(false),
      decline: ref(false),
    });

    let isForm = ref({
      EntityOperationId: 0,
      Id: 0,
      EntityApprovalMapID: 0,
      EntityTransactionId: 0,
      ApproverID: usersData.UserId,
      DepRoleID: rolesData.DeptRoleMapId,
      IsApproved: 0,
      ApprovedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      Remarks: "",
      EntityId: 0,
    });

    async function Approve(Values) {
      debugger;
      try {
        // isForm.value.EntityOperationId =
        //   ApprovalListchange.value[0]["EntityOperationId"];
        // isForm.value.Id = ApprovalListchange.value[0]["ID"];
        // isForm.value.EntityTransactionId =
        //   ApprovalListchange.value[0]["EntityTransactionId"];

        // isForm.value.IsApproved = Values.Approvalstatus;
        // isForm.value.Remarks = Values.Remarks;

        let rowToAssign = null;

        for (let i = 0; i < ApprovalListchange.value.length; i++) {
          if (ApprovalListchange.value[i]["IsApproved"] === 0) {
            rowToAssign = ApprovalListchange.value[i];
            break; // Exit the loop once the first matching row is found
          }
        }

        if (rowToAssign) {
          isForm.value.EntityOperationId = rowToAssign["EntityOperationId"];
          isForm.value.Id = rowToAssign["ID"];
          isForm.value.EntityTransactionId = rowToAssign["EntityTransactionId"];

          isForm.value.IsApproved = Values.Approvalstatus;
          isForm.value.Remarks = Values.Remarks;
          isForm.value.EntityId = details.value.EntityId;
        }

        let response;
        if (isForm.value.IsApproved == 1) {
          response = await PoApprovalService.POApproval(isForm.value);
          if (response["ErrorInfo"].ErrorCode == null) {
            if (response["result"] == 1) {
              UpdateApprovalStatus();
            }
            SuccessfullPopUp.value.accept = true;
          } else {
            alert("Somthing went wrong");
          }
        } else if (isForm.value.IsApproved == 3) {
          response = await PoApprovalService.POReject(isForm.value);
          if (response["ErrorInfo"].ErrorCode == null) {
            UpdateApprovalStatus();
            SuccessfullPopUp.value.decline = true;
          } else {
            alert("Somthing went wrong");
          }
        }
      } catch (error) {
        console.log(error);
      }
    }

    async function UpdateApprovalStatus() {
      debugger;
      try {
        const response = await commonService.UpdateApprovalStatus(
          QueryStringValue.value.Id,
          isForm.value.IsApproved
        );

        let message = response["ErrorInfo"].ErrorCode;

        if (message == null) {
          POdetails();
        }
      } catch (error) {
        console.log(error);
      }
    }
    const AddItems = (value) => {
      debugger;
      console.log(value);
      itemslist.value = value;
    };
    function removeHtmlTags(input: string): string {
      return input?.replace(/<\/?[^>]+>/gi, ""); // Regular expression to match HTML tags
    }
    function fileviewer(data) {
      debugger
      const newTabUrl = data;
      window.open(newTabUrl, '_blank');
    }
    return {
      removeHtmlTags,
      getConvertedDate,
      getApprovaldata,
      ApprovalListchange,
      details,
      ApprovalList,
      ModelPopupDunction,
      cancelclose,
      Statuschange,
      datapass,
      handleClick,
      showpopModal: showmodalref,
      sidebardata,
      isActive,
      item,
      items,
      activeIndex,
      fileviewer,
      currentStatus,
      next,
      prev,
      menu,
      toggle,
      Id,
      loading,
      SummaryName,
      UpdateApprovalStatus,
      approvaldetails,
      Approve,
      SuccessfullPopUp,
      ObjCancelPopUp,
      SaveCancelPO,
      RevertPO,
      AddItems,
      itemslist,
      QueryStringValue,
      uploadedTableList
    };
  },
});
</script>

<style lang="scss" scoped>
.col-xl-2 {
  width: 19.666667%;
}

.col-xl-10 {
  width: 80.333333%;
}

.sidebar-static-header {
  padding: 15px 15px 20px 45px;
  font-weight: 600;
  border-bottom: 5px solid #f8f9fe;
  position: sticky;
  left: 0px;
  top: 0px;
  background-color: #f8f9fe;
  z-index: 1;
}

.other-tabs {
  height: 90vh;
  padding-left: 5px !important;
  overflow: auto;
}

// .overall-bg {
//   section {
//     width: 100%;
//     overflow: hidden;
//   }
// }

.leftsidebar {
  position: relative;
  padding-right: 0px !important;
}

.back-btn {
  background-color: #0148e2;
  border-radius: 50%;
  height: 35px;
  width: 35px;
  position: absolute;
  top: 20px;
  right: -12px;
  z-index: 1000;

  .back {
    width: 20px;
    position: absolute;
    top: -45px;
    left: 8px;
  }
}

.count-shows {
  font-weight: 300;
  padding-bottom: 10px;
}

.card-font {
  font-size: small;
}

.Actionsbtn {
  background-color: #4a8fe9 !important;
  border: none !important;
  padding: 8px !important;
}

.overall-bg {
  background-color: #f8f9fe;
  padding: 0;
  height: auto;
}

.header-top {
  margin-top: 0px !important;
}

.steps .p-tabview-header {
  width: 20% !important;
}

.steps .p-tabview-header-action {
  justify-content: center !important;
}

.Tabheading {
  font-size: small;
}

.summarycard {
  font-size: small !important;

  .termstxt {
    word-wrap: break-word;
  }
}

.p-tabview .p-tabview-nav li .p-tabview-nav-link {
  border: none !important;
}

.pi-check-circle {
  color: green;
  letter-spacing: 7px;
}

.sidebar-det-list {
  color: black !important;
}

.width80 {
  width: 80%;
}

@media only screen and (max-width: 1024px) {
  .width80 {
    width: 100%;
  }
}
</style>
